'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment'];
module.exports = angular.module('AVRO.Common.Ranges', dependencies).factory('RangesCalculatorService', require('./services/RangesCalculatorService'));